import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { TextField, Checkbox, FormControlLabel } from "@mui/material";
import Alert from "../components/Alert/Alert.jsx";
import style from "../components/LoginForm/LoginForm.module.css";
import { useTranslation } from 'react-i18next';
import { resetPassword, changePassword } from "../api/auth";

const ResetPassword = () => {
  const [params] = useSearchParams();
  const resetToken = params.get("token");
  const navigate = useNavigate();

  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [oldPassword, setOldPassword] = useState(""); // для залогіненого
  const [showPasswords, setShowPasswords] = useState(false);
  const [alert, setAlert] = useState({ show: false, text: "", type: "" });

  const isLoggedIn = !resetToken;

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (isLoggedIn) {
        await changePassword(oldPassword, password);
      } else {
        await resetPassword(resetToken, password);
      }
      setAlert({ show: true, text: t('reset_password.success'), type: "success" });
      setTimeout(() => navigate(isLoggedIn ? "/dashboard" : "/login"), 2000);
    } catch (err) {
      setAlert({ show: true, text: err.message, type: "error" });
    }
  };

  return (
    <>
      {alert.show && (
        <Alert
          text={alert.text}
          type={alert.type}
          onClose={() => setAlert({ show: false, text: "", type: "" })}
        />
      )}  
      
      <div className={`${style.forgotPassword} ${style.formContainer}`}>
        <h2 className={style.formHeader}>{isLoggedIn ? t('reset_password.title') : t('reset_password.page_title')}</h2>
        <form onSubmit={handleSubmit} className={`${style.form} ${style.forgotPassForm}`}>
          <div className={style.forgotPassInput}>
            {isLoggedIn && (
              <TextField 
                type={showPasswords ? "text" : "password"}
                name="oldPassword" 
                value={oldPassword} 
                onChange={(e) => setOldPassword(e.target.value)}
                required 
                label={t('reset_password.current')}
                placeholder={t('reset_password.current')}
                fullWidth
                margin="normal"
              />
            )}
            <TextField 
              type={showPasswords ? "text" : "password"}
              name="password" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)}
              required 
              label={t('reset_password.new')}
              placeholder={t('reset_password.new')}
              fullWidth
              margin="normal"
            />
            <FormControlLabel
              sx={{
                marginBottom: "20px"
              }}
              control={
                <Checkbox
                  checked={showPasswords}
                  onChange={() => setShowPasswords(!showPasswords)}
                  sx={{
                    color: "#664499",
                    "&.Mui-checked": {
                      color: "#664499",
                    },
                  }}
                />
              }
              label={t('auth.show_password')}
            />
          </div>
          <div className={style.buttonsContainer}> 
            <button type="submit" className={`button ${style.loginButton} ${style.resetPassButton}`}>
              {t('reset_password.submit')}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default ResetPassword;
